export default __webpack_public_path__ + "static/media/Sri-Venkateswara-temple-TTD-Tirumala.55412833.jpg";